.form {
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
}

.section {
	margin-bottom: 1.5rem;
}

.fieldsGrid {
	display: grid;
	grid-template-columns: repeat(12, 1fr);
	gap: 1rem;
}
